module.exports = __webpack_public_path__ + "img/icons/google-7fd162b327d42b755efbe828d0a329b7.svg";